/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

/** Slice */
import { clearUser, storeUser } from "../../store/userSlice";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

/** Component  */
import ButtonWithAPICallComponent from "../commons/ButtonWithAPICall.component";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { Container, CssBaseline, Avatar, Typography, TextField } from "@mui/material";

/** Api */
import { login, getUserProfile } from "../../services/api";
import { passEncrypt } from "../../services/libService";

/** Icons  */

import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { styles } from "../styles";

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [inputData, setInputData] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    dispatch(clearUser());
  }, []);

  const handleLogin = () => {
    return login({
      email: inputData.email,
      password: passEncrypt(inputData.password),
      // password: inputData.password,
    });
  };
  const handleResponse = (res) => {
    if (res.code === 200) {
      if (res.user.customer_id) {
        enqueueSnackbar("Tài khoản không được xác thực!");
        return;
      }
      localStorage.setItem("token", res.token);
      getUserProfile().then((res) => {
        if (res.code === 200) dispatch(storeUser({ ...res.data[0], permissions: JSON.parse(res.data[0].permissions) }));
      });
      history.push("/");
    }
  };
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div style={styles.paper}>
        <Typography gutterBottom variant="h6" component="h2">
          {t("login")}
        </Typography>
        <Avatar>
          <LockOutlinedIcon />
        </Avatar>

        <form noValidate autoComplete="off" style={styles.form_center} onSubmit={handleLogin}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            type="email"
            value={inputData.email}
            size="small"
            autoComplete="email"
            autoFocus
            onChange={(e) => setInputData((prev) => ({ ...prev, email: e.target.value }))}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="password"
            label="Password"
            type="password"
            value={inputData.password}
            autoComplete="current-password"
            size="small"
            onChange={(e) => setInputData((prev) => ({ ...prev, password: e.target.value }))}
          />
          <ButtonWithAPICallComponent type="submit" disableSnackbar={(res) => res.code === 200} variant="contained" fullWidth api={handleLogin} response={handleResponse}>
            Đăng nhập
          </ButtonWithAPICallComponent>
        </form>
      </div>
    </Container>
  );
};

export default Login;
